<script>
    import Icon from '../../components/Icon.svelte'
    import { getContacts as GetContacts } from '../../domain/call/contact.action'
    import { onMount } from "svelte";
    import sessionStore from 'store/session'
    import contactStore from '../../store/contact';
    import AuthHeader from '../../components/AuthHeader.svelte';
    import AuthFooter from '../../components/AuthFooter.svelte';
    import InfiniteScroll from 'svelte-infinite-scroll'
    import { useNavigate } from 'svelte-navigator'
    import { formatNumber, pickOutInitials } from '../../services/utils';
    import { initiateCall } from '../../domain/call/telephony.actions';
    import pubsub from 'sweet-pubsub'

    let loading = false;
    let search = '';
    const navigate = useNavigate()

    const loadMoreContacts = async () => {
        loading = true
        try {
            const { data, nb_pages, page_index } = await GetContacts($sessionStore.profile.business.id, $contactStore.page+1)
            contactStore.updateContact(data)
            contactStore.update({
                page: page_index,
                total_page: nb_pages
            })
            pubsub.emit('contact_fetched', {
                contacts: data,
                page: page_index,
                total_page: nb_pages
            })
        } catch (error) {
            console.log(error)
        } finally {
            loading = false
        }
    }

    $: filtered_contacts = $contactStore.contacts.filter(({name, number}) => {
        const __search__ = search.toLowerCase();
        return name.toLowerCase().includes(__search__) || number.toLowerCase().includes(__search__)
    });

    const bg_colors = ['from-green-400 to-blue-500', 'from-yellow-400 to-purple-500', 'from-sky-400 to-blue-500', 'from-orange-400 to-red-500', 'from-red-400 to-pink-500']

    onMount( async () => {
        await loadMoreContacts()
    })
    
</script>

<AuthHeader />
<div class="flex h-full flex-col mx-4">
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <h3 class="text-md font-bold mt-2 flex justify-between items-center" on:click={() => navigate("/add-contact")}>
        Contact
        <small class="text-xs">
            + new contact
        </small>
    </h3>
    <div>
        <div class="flex mt-4">
            <input
                placeholder="Search Contact"
                bind:value={search}
                class="border-0 border-b border-black mr-2 px-2 py-1 text-sm"
            />
        </div>
        <div class="pb-40 overflow-y-scroll h-auto" style="height: 20rem;">
            <ul>
                {#if filtered_contacts.length > 0}
                    {#each filtered_contacts as contact, i}
                    <li class="flex justify-between my-5">
                        <div class="flex">
                            <!-- svelte-ignore a11y-click-events-have-key-events -->
                            <div 
                                on:click={() => navigate("/add-contact", {state: contact})}
                                class="flex justify-center items-center bg-gradient-to-r {bg_colors[i%bg_colors.length]} rounded-full h-10 w-10 text-white cursor-pointer"
                            >
                                { pickOutInitials(contact.name) }
                            </div>
                            <!-- svelte-ignore a11y-click-events-have-key-events -->
                            <div class="ml-2">
                                <div class="font-light text-xs cursor-pointer" on:click={() => navigate("/add-contact", {state: contact})}>{ contact.name }</div>
                                <div class="text-gray-500 text-xs flex cursor-pointer" on:click={initiateCall(formatNumber(contact.number), {})}>
                                    <span>{ contact.number }</span>
                                </div>
                            </div>
                        </div>
                        <div class="flex">
                            <!-- svelte-ignore a11y-click-events-have-key-events -->
                            <div class="flex justify-center items-center text-gray-700 mr-2 text-xs underline cursor-pointer" on:click={() => navigate("/add-contact", {state: contact})}>View details</div>
                            <!-- svelte-ignore a11y-click-events-have-key-events -->
                            <div class="flex justify-center items-center primary-bg-color rounded-full h-10 w-10 text-white cursor-pointer" on:click={initiateCall(formatNumber(contact.number), {})}>
                                <Icon icon="call" color="#ffffff"/>
                            </div>
                        </div>
                    </li>
                    {/each}
                {:else if !loading}
                    <div class="flex justify-center items-center h-4/6" style="height: 16rem;">
                    Ops!. No contact record
                    </div>
                {/if}
                {#if loading}
                <div class="flex justify-center items-center h-4/6" style="height: 16rem;">
                    <Icon Icon="loader" />
                    <i class="animate-pulse">loading record...</i>
                </div>
                {/if}
            </ul>
            <InfiniteScroll
                hasMore={$contactStore.page < $contactStore.total_page}
                threshold={5}
                on:loadMore={() => loadMoreContacts()}
            />
        </div>
    </div>
</div>
<AuthFooter />
<style>
    .primary-bg-color {
        background-color: var(--primary-bg-color)
    }
</style>